<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6691_9032)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 -0.000488281C14.8954 -0.000488281 14 0.89497 14 1.99957V13.9993H1.99908C0.894481 13.9993 -0.000976562 14.8947 -0.000976562 15.9993C-0.000976562 17.1039 0.894481 17.9994 1.99908 17.9994H14V30.0004C14 31.105 14.8954 32.0005 16 32.0005C17.1046 32.0005 18.0001 31.105 18.0001 30.0004V17.9994H29.9999C31.1045 17.9994 32 17.1039 32 15.9993C32 14.8947 31.1045 13.9993 29.9999 13.9993H18.0001V1.99957C18.0001 0.89497 17.1046 -0.000488281 16 -0.000488281Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_6691_9032">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
